import { render } from "./ReturnRefund.vue?vue&type=template&id=cbdd8b06&scoped=true"
import script from "./ReturnRefund.vue?vue&type=script&lang=js"
export * from "./ReturnRefund.vue?vue&type=script&lang=js"

import "./ReturnRefund.vue?vue&type=style&index=0&id=cbdd8b06&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cbdd8b06"

export default script